import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import whitepaperApi from "../api/whitepaper";
import { sendError } from "../errors";

export const fetchWhitepapers = createAsyncThunk(
  "whitepaper/fetchWhitepapers",
  async () => {
    return await whitepaperApi.all();
  }
);

export const whitepaperSlice = createSlice({
  name: "whitepaper",
  initialState: {
    items: [],
    loading: false,
    loadingError: false,
    loaded: false,
  },
  reducers: {},
  extraReducers: (builder, x) => {
    builder.addCase(fetchWhitepapers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchWhitepapers.fulfilled, (state, action) => {
      state.items = action.payload;
      state.loading = false;
      state.loaded = true;
    });
    builder.addCase(fetchWhitepapers.rejected, (state, action) => {
      sendError("Could not load whitepaper via API", { error: action.error });
      state.loadingError = action.error;
      state.loading = false;
      state.loaded = true;
    });
  },
});

export default whitepaperSlice.reducer;
